// OpenAI ChatGPT Ads measurement pixel (oaiq). The loader lives in public/index.html;
// these helpers fire the documented events. No-ops when the pixel is absent.
// Docs: https://developers.openai.com/ads/measurement-pixel

export function measurePageView(path = window.location.pathname + window.location.search) {
  if (typeof window.oaiq !== "function") return;
  window.oaiq("measure", "page_viewed", {
    type: "contents",
    contents: [{ id: path, name: document.title || path, content_type: "page" }],
  });
}

// Fire only after the backend has accepted the lead. event_id lets OpenAI deduplicate
// against any future server-to-server (Conversions API) event with the same id.
export function measureLead(eventId) {
  if (typeof window.oaiq !== "function") return;
  const id = eventId || (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
  window.oaiq("measure", "lead_created", { type: "customer_action" }, { event_id: id });
}
